import { apiRequest } from './core';

// Dashboard API types and functions
export interface DashboardStats {
  students: { total: number };
  classes: { total: number };
  staff: { total: number };
  parents: { total: number };
  blocks: { total: number };
  schoolYear: {
    id: string;
    name: string;
    startDate: string;
    endDate: string;
  } | null;
  dataCompleteness: {
    classesWithoutMeetingPatterns: number;
    studentsWithoutEnrollment: number;
    blocksWithoutPatterns: number;
  };
}

export const dashboardApi = {
  getStats: async () => apiRequest<{ success: boolean; data: DashboardStats }>('/api/dashboard/stats'),
};
